module.exports = __webpack_public_path__ + "media/src/images/about/outline/mypage@2x-f05507eef64d4752a57bb7c2437261d4.png";